// @ts-nocheck
import { Col, Row } from "antd";
import { Fragment, h } from "preact";
import { MemoizedFileUpload } from "./file";
import { MemoizedImageUpload } from "./image";
import {
  MemoizedInput,
  MemoizedTextAreaAntd,
  MemoizedInputSeach,
} from "./input/input";
import { MemoizedRadio } from "./radio";
import { MemoizedSelect } from "./select";
import { MemoizedDatePicker } from "./date/date";
import { MemoizedSelectModal } from "./select/select-modal";
import { MemoizedLinkUrl } from "./link";

interface IBaseForm {
  forms: any[];
  onChange?: () => null;
  onClear?: () => null;
  styleRow?: any;
  setValue?: any;
  control: any;
  getValues?: any;
}

export const BaseForm = ({
  forms,
  setValue,
  getValues,
  control,
  styleRow,
  onChange,
  onClear,
}: IBaseForm) => {
  function handleChange(e, item, option) {
    if (!e) {
      return;
    }
    switch (item.type) {
      case "SELECT":
      case "SELECT_MULTI":
      case "DATEPICKER":
        setValue(item.ref, e);
        break;
      case "FILE_UPLOAD":
      case "IMAGE_UPLOAD":
        setValue(item.ref, e.fileList);
        break;
      case "SELECT_MODAL":
        setValue(item.ref, e);
        break;
      default:
        setValue(item.ref, e.target.value);
        break;
    }
    onChange && onChange(e, item, option);
  }

  function handleClear(e, item) {
    setValue(item.ref, "");
    onClear && onClear(e, item);
  }

  const rest: any = {
    control,
    setValue,
    getValues,
    handleChange,
    handleClear,
  };

  return (
    <Row gutter={[12, 12]} style={styleRow}>
      {forms.map((f, i) => {
        return (
          !f.hidden && (
            <Col
              key={i}
              xs={{ span: 24 }}
              md={{ span: 24 }}
              xl={{ span: f.span }}
              lg={{ span: f.span }}
              style={{ ...f.style }}
            >
              {onRenderFormType(f, rest)}
            </Col>
          )
        );
      })}
    </Row>
  );
};

const onRenderFormType = (e: any, rest: IBaseForm) => {
  switch (e.type) {
    case "INPUT":
      return <MemoizedInput item={e} {...rest} />;
    case "INPUTSEARCH":
      return <MemoizedInputSeach item={e} {...rest} />;
    case "TEXTAREA":
      return <MemoizedTextAreaAntd item={e} {...rest} />;
    case "SELECT":
      return <MemoizedSelect item={e} {...rest} />;
    case "SELECT_MULTI":
      return <MemoizedSelect item={{ ...e, mode: "multiple" }} {...rest} />;
    case "SELECT_MODAL":
      return (
        <MemoizedSelectModal item={{ ...e, mode: "multiple" }} {...rest} />
      );
    case "FILE_UPLOAD":
      return <MemoizedFileUpload item={e} {...rest} />;
    case "IMAGE_UPLOAD":
      return <MemoizedImageUpload item={e} {...rest} />;
    case "RADIO":
      return <MemoizedRadio item={e} {...rest} />;
    case "DATEPICKER":
      return <MemoizedDatePicker item={e} {...rest} />;
    case "LINK_URL":
      return <MemoizedLinkUrl item={e} {...rest} />;
    default:
      return <></>;
  }
};

export default BaseForm;
